$(document).ready(function(){



  let language = document.body.getAttribute("language");
  
	var choice = "";
	var col_choice = "";
	var size = "";
	var bundle = [];
	var temp_title;
	var temp_image;
	var temp_id;
	var temp_prod_id;
	var bundle_buy_1;
	var bundle_save_1;
	var bundle_buy_2;
	var bundle_save_2;
	var bundle_buy_3;
	var bundle_save_3;
	var temp_step_1_gender;
	var bamboo = false;
  
	const defaults = {
	spread: 360,
	ticks: 50,
	gravity: 0,
	decay: 0.94,
	startVelocity: 30,
	shapes: ["star"],
	colors: ["FFE400", "FFBD00", "E89400", "FFCA6C", "FDFFB8"],
  };
  
  function shoot() {
	confetti({
	  ...defaults,
	  particleCount: 40,
	  scalar: 1.2,
	  shapes: ["star"],
	});
  
	confetti({
	  ...defaults,
	  particleCount: 10,
	  scalar: 0.75,
	  shapes: ["circle"],
	});
  }
  
	
   $('body').on('click', '#bab-men', function(){
     $('.small-size').each(function () {
          $(this).removeClass("unavailable");
        })
	   $('.bab-type-choice').each(function(){
		 $(this).addClass("hidden");
	   })
	   $('#bab-men-choice').removeClass("hidden");
	   $('#bab-size-choice').removeClass("hidden");
	   $('#bab-men-size').removeClass("hidden");
	   $('#bab-women-size').addClass("hidden");
	   $('#bab-gender-slider').css("left", "0%");
	   $('#bab-gender-slider').removeClass("hidden");
	   $('.bab-gender').each(function(){
		 $(this).removeClass("active text-white");
		 $(this).removeClass("pointer-events-none text-white");
	   })
	 $('.bab-type').each(function(){
		$(this).removeClass("bab-active");
	  })
  
	 $('#bab-men-boxer').addClass("bab-active");
	 choice = "mens-boxer-shorts-individuals";
	 col_choice = "278855811133";
   })
  
  
	$('body').on('click','#bab-return-home-button', function(){
	  bundle = [];
	  $('#bab-loading').show();
	  $('#bab-loaded').hide();
	  $('#bab-patterned-prods').empty();
	  $('#bab-plain-prods').empty();
	  $('#bab-bamboo-prods').empty();
	  $('#bab-bundle-step').hide();
	  $('#bab-info-step').show();
	  if($('#show-bab').text()==$('#show-bab').data("text-2")){
		$('#show-bab').trigger('click');
	  }
	})
	
	$('body').on('click', '#bab-women', function(){
      $('.small-size').each(function () {
          $(this).removeClass("unavailable");
        })
	   $('.bab-type-choice').each(function(){
		 $(this).addClass("hidden");
	   })
		$('#bab-gender-slider').css("left", "50%");
		$('#bab-women-choice').removeClass("hidden");
		$('#bab-size-choice').removeClass("hidden");
		$('#bab-gender-slider').removeClass("hidden");
		$('#bab-women-size').removeClass("hidden");
		$('#bab-men-size').addClass("hidden");
		$('.bab-gender').each(function(){
		 $(this).removeClass("active text-white");
		 $(this).removeClass("pointer-events-none text-white");
	   })
	  $('.bab-type').each(function(){
		$(this).removeClass("bab-active");
	  })
  
	  choice = "ladies-boxer-shorts-individuals";
	  col_choice = "278856073277";
	  $('#bab-women-boxer').addClass("bab-active");
	 })
  
	$('body').on('click', '.bab-type', function(){
      if($(this).hasClass("js-bab-bamboo")){
        $('.small-size').each(function () {
          $(this).addClass("unavailable");
        })
        if($('.small-size.bab-active').length){
          $('.small-size.bab-active').removeClass("bab-active");
          $('#bab-finish').removeClass("bab-active");
          $('#bab-finish').text(translations.bab.empty_button);
        }
      }else{
        $('.small-size').each(function () {
          $(this).removeClass("unavailable");
        })
      }
	  choice = $(this).data("type");
	  col_choice = $(this).data("col-id");
	  $('.bab-type').each(function(){
		$(this).removeClass("bab-active");
	  })
	  $(this).addClass("bab-active");
	})
  
	$('body').on('click', '.bab-size', function(){
	  size = $(this).data("size");
	  $('.bab-size').each(function(){
		$(this).removeClass("bab-active");
	  })
	  $(this).addClass("bab-active");
	   $('#bab-finish').text(translations.bab.full_button);
      $('#bab-finish').removeClass("pointer-events-none")
		$('#bab-finish').addClass("bab-active");
	})
  
	$('body').on('click','.bab-gender', function(){

	  $('#bab-finish').removeClass("hidden");
	  $('#bab-finish').text(translations.bab.empty_button);
		$('#bab-finish').removeClass("bab-active");
	  temp_step_1_gender = $(this).data("gender");
	 
	})
  
	  var bab_choice;
	$('body').on('click', '#bab-finish', function(){
	  $('#bab-secondary-panel').addClass("bab-finished")
	  $('#bab-info-step').hide();
	  $('#bab-bundle-step').show(); 
       $('html, body').scrollTop($('#bundle-title').offset().top);
      $('#bab-left-col').addClass('max-md:hidden')
	  if(choice == "mens-boxer-shorts-individuals"){
		bab_choice = "Mens boxer"
		prod_handle = "fat-cow-mens-boxer-shorts"
	  }
	  if(choice == "mens-bamboo-boxer-shorts-individuals"){
		bab_choice = "Mens bamboo boxer"
		prod_handle = "wildflower-mens-bamboo-boxer-shorts"
	  }
	  if(choice == "mens-briefs-individuals"){
		 bab_choice = "Mens brief";
		prod_handle = "fat-cow-mens-briefs"
	  }
	  if(choice == "ladies-boxer-shorts-individuals"){
	   bab_choice = "Ladies boxer";
		prod_handle = "fat-cow-ladies-boxers"
	  }
	  if(choice == "ladies-briefs-individuals"){
	 bab_choice = "Ladies brief";
		prod_handle = "fat-cow-ladies-brief"
	  }
	  if(choice == "ladies-thongs-individuals"){
		 bab_choice = "Thong";
		prod_handle = "fat-cow-ladies-thongs"
	  }
	  if(choice == "seamless-individuals"){
		 bab_choice = "Seamless";
		prod_handle = "seamless-brazilian-briefs-fat-cow"
	  }
	  if(choice == "full-seamless-individuals"){
		 bab_choice = "Seamless Full Brief";
		prod_handle = "fat-cow-seamless-full-briefs"
	  }
	  if(choice == "ladies-bamboo-boxer-shorts-individuals"){
		bab_choice = "Women's Bamboo"
		prod_handle = "space-balls-ladies-bamboo-boxers";
	  }
	  const bundleName = choice.replace(/-/g, " ").replace(/individuals/g, "bundle");
	  $('.js-current_bundle_title').each(function(){
		$(this).text(bundleName)
	  })
	  $('#bab-bundle-type').text(bab_choice + "s")
	  var in_cart = 0;
  
	  var url1 = `/products/${prod_handle}?view=ob-prod_bundle`;
		var params1 = {
		  type: 'GET',
		  url: url1,
		  dataType: 'html'
		};
	$('#bab-header-current-size').text(size);
		$.ajax(params1).done(function (response1) {
		  var tempDiv = $('<div>').html(response1);
		  bundle_buy_1 = tempDiv.find('#buy-1').text();
		  bundle_save_1 = tempDiv.find('#save-1').text();
		  bundle_buy_2 = tempDiv.find('#buy-2').text();
		  bundle_save_2 = tempDiv.find('#save-2').text();
		  bundle_buy_3 = tempDiv.find('#buy-3').text();
		  bundle_save_3 = tempDiv.find('#save-3').text();
		  const n1 = bundle_buy_1;
		  const n3 = bundle_buy_3;
		  const n2 = bundle_buy_2;
		  const n1thDiv = $('#bab-bot-row .grid div:not(.absolute)').eq(n1 - 1); 
		  const n2thDiv = $('#bab-bot-row .grid div:not(.absolute)').eq(n2 - 1); 
		  const n3thDiv = $('#bab-bot-row .grid div:not(.absolute)').eq(n3 - 1); 
		  // n1thDiv.find('.bab-price-marker').addClass("text-magenta-500");
		  // n2thDiv.find('.bab-price-marker').addClass("text-magenta-500");
		  // n3thDiv.find('.bab-price-marker').addClass("text-magenta-500");
		  $('#bab-milestone-1').text(bundle_buy_1);
          
		  $('#bab-milestone-2').html(bundle_buy_2);
		  $('#bab-milestone-3').html(bundle_buy_3);
		  $('#bab-savings-1').text("£" + bundle_save_1 * bundle_buy_1);
		  $('#bab-savings-2').text("£" + bundle_save_1 * (parseInt(bundle_buy_1) + 1));
		  $('#bab-savings-3').text("£" + bundle_save_1 * (parseInt(bundle_buy_1) + 2));
		  $('#bab-savings-4').html("£" + bundle_save_2 * bundle_buy_2  + "");
		  $('#bab-savings-5').html("£" + bundle_save_2 * (parseInt(bundle_buy_2) + 1));
		  $('#bab-savings-6').html("£" + bundle_save_2 * (parseInt(bundle_buy_2) + 2));
		  $('#bab-savings-7').html("£" + bundle_save_3 * bundle_buy_3  + "");
  
		  
		  $.getJSON('/cart.js', function (cart) {//get items from the cart into the bundle
			var bundle_choice = "";
		var temp_price = 0;
		  $.each(cart.items, function (index, item) {
              bundle_choice = "";
			  var title_parts = item.title.split('-');
			  var item_size = item.variant_options[0];
			  if(item.properties._Bundle){
				  bundle_choice = item.properties._Bundle;
			  }
			if(bundle_choice != ""){
			  if(bundle_choice.toLowerCase().includes(bab_choice.toLowerCase())){
				  var quantity = item.quantity;
				  var handle = item.handle;
				  var price = item.price/100;
				  temp_price =  price;
				  var id = item.variant_id
				  bundle_in_cart = true;
				  bundle.push([0, item.title, id,item.featured_image.url, quantity]);
				in_cart += quantity
				
			  }
			}
		  })
			if(in_cart == 0){
			  $('#included-from-cart').hide();
			}
		$('#items-in-bundle-footer').text(in_cart);
			bundleUpdate(temp_price);
		  })
  
		});
	  getProducts();
	})
  
	$('body').on('click','#bab-bamboo-prints', function(){
	  $('#bab-patterned-prods').hide();
	  $('#bab-plain-prods').hide();
	  $('#bab-bamboo-prods').show();
	})
	$('body').on('click','#bab-plain-prints', function(){
	  $('#bab-patterned-prods').hide();
	  $('#bab-plain-prods').show();
	})
	$('body').on('click','#bab-patterned-prints', function(){
	  $('#bab-patterned-prods').show();
	  $('#bab-plain-prods').hide();
	})
  
	$('body').on('click', '.js-bab-safety-screen', function(){
	  $('#bab-pop-up').hide();
	})
  
	$('body').on('click', '#bab-popup-button', function(){
	  var found = false;
		bundle.push([1,temp_title, temp_id, temp_image,1, temp_prod_id]);
	  bundleUpdate();
	  $('#bab-pop-up').hide();
		$('.active-bab-pair').removeClass('active-bab-pair')
		  const n = bundle.reduce(function(accumulator, currentValue) {
			return accumulator + (currentValue[4] || 1);
		  }, 0);
  
		const nthDiv = $('#bab-top-row .grid div:not(.absolute)').eq(n - 1); 
		const nthDivTwo = $('#bab-bot-row .grid div:not(.absolute)').eq(n - 1); 
		nthDiv.find('.bab-comp-marker').addClass("grow-shrink-div active-bab-pair");
		nthDivTwo.find('.bab-price-marker').addClass("grow-shrink-div active-bab-pair");
		const the_bundle_length_const = get_bundle_length(bundle);
    	 setTimeout(function(){
		if(the_bundle_length_const == bundle_buy_1){
		  const rect = nthDiv[0].getBoundingClientRect();
		  const x = (rect.left + rect.right) / 2 / window.innerWidth;
		  const y = (rect.top + rect.bottom) / 2 / window.innerHeight;
		  confetti({
              shapes: ["star"],
              colors: ["FFE400", "FFBD00", "E89400", "FFCA6C", "FDFFB8"],
			  particleCount: 100,
			  spread: 70,
			  origin: { x, y } // Position calculated based on the element's location
		  });
		}
		if(the_bundle_length_const == bundle_buy_2){
		  const rect = nthDiv[0].getBoundingClientRect();
		  const x = (rect.left + rect.right) / 2 / window.innerWidth;
		  const y = (rect.top + rect.bottom) / 2 / window.innerHeight;
		  
		  confetti({
			  particleCount: 100,
			  spread: 70,
			  origin: { x, y } // Position calculated based on the element's location
		  });
		}
		if(the_bundle_length_const == bundle_buy_3){
		  const rect = nthDiv[0].getBoundingClientRect();
		  const x = (rect.left + rect.right) / 2 / window.innerWidth;
		  const y = (rect.top + rect.bottom) / 2 / window.innerHeight;
		  
		  const duration = 3 * 1000,
		  animationEnd = Date.now() + duration,
		  defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };
  
		function randomInRange(min, max) {
		  return Math.random() * (max - min) + min;
		}
		
		const interval = setInterval(function() {
		  const timeLeft = animationEnd - Date.now();
		
		  if (timeLeft <= 0) {
			return clearInterval(interval);
		  }
		
		  const particleCount = 50 * (timeLeft / duration);
		
		  // since particles fall down, start a bit higher than random
		  confetti(
			Object.assign({}, defaults, {
			  particleCount,
			  origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
			})
		  );
		  confetti(
			Object.assign({}, defaults, {
			  particleCount,
			  origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
			})
		  );
		}, 250);
		}
	  }, 500)
	  setTimeout(function(){
		nthDiv.find('.bab-comp-marker').removeClass("grow-shrink-div");
		nthDivTwo.find('.bab-price-marker').removeClass("grow-shrink-div");
	  }, 1000)
  
	})
  
	
	$('body').on('click', '.bab-bundle-item', function(){
  
	  try{
		fbq('track', 'ViewContent', {
		  content_ids: [$(this).data("var_id")],
		  content_name: [$(this).data("handle")],
		  content_type: 'product'
		});
		}catch(error){
		  console.error(error)
		}
  
	  
	  $('#bab-pop-up').show();
	  $('#bab-popup-title').text($(this).data("title"))
	  $('#bab-popup-size').text(size);
	  $('#bab-popup-img img').attr("src", $(this).find('img').attr("src")).attr("srcset",$(this).find('img').attr("srcset"));
	  
	  temp_title = $(this).data("title");
	  temp_id = $(this).data("var_id");
	  temp_prod_id = $(this).data("prod_id");
	  temp_image = $(this).find("img").attr("src")
  
	})
	function get_bundle_length(bundle) {
		return bundle.reduce((total, item) => {
			// Add the quantity of each item (stored in item[4])
			// If item[4] is undefined, default to 1
			return total + (item[4] || 1);
		}, 0);
	}
	
	$('body').on('click','#show-bab', function(){
	  if($(this).text()==$(this).data("text-2")){
		$(this).text($(this).data("text-1"))
	  }else{
		$(this).text($(this).data("text-2"))
	  }
	  $('#bab-showing-prods').toggle();
	  $('#bab-showing-bundle').toggle();
	})
  
	$('body').on('click', '#add-bab-to-cart', function(){
			  newBundle = bundle.filter(function(item){
				return item[0] == 1;
			  })
      $('#bab-left-col').removeClass('max-md:hidden')
      $('html, body').scrollTop($('#bab-left-col').offset().top);
	  var bundleIds = newBundle.map(function(item){
		return(item[2])
	  })
	  addToCartRecursive(0)
	})
  
  
	$('body').on('click', '.js-bab-remove-button', function() {
		const item = $(this).closest('.bundle-item');
		const id = item.data('id');
		let found = false;
		bundle = bundle.filter(function(item) {
			if (!found && item[2] == id && item[0] == 1) {
				found = true;
				return false;
			}
			return true;
		});
	  newBundle = bundle.filter(function(item){
		return item[0] == 1;
	  })
	  if(newBundle .length == 0){
		$('#bab-showing-prods').show();
		$('#bab-showing-bundle').hide();
	  }
		item.remove();
	  bundleUpdate();
	  const n = get_bundle_length(bundle);
	  const nthDiv = $('#bab-top-row .grid div:not(.absolute)').eq(n - 1); 
	  const nthDivTwo = $('#bab-bot-row .grid div:not(.absolute)').eq(n - 1); 
	  $('.active-bab-pair').removeClass('active-bab-pair')
	  
	  nthDiv.find('.bab-comp-marker').addClass("active-bab-pair");
	  nthDivTwo.find('.bab-price-marker').addClass("active-bab-pair");
	});
  
	$('body').on('click' ,'#bab-restart', function(){
	  location.reload();
	})

  const typeMap = new Map([
  ["mens-boxer-shorts-individuals", "Boxer Shorts"],
  ["mens-bamboo-boxer-shorts-individuals", "Bamboo Boxer Shorts"],
  ["mens-briefs-individuals", "Briefs"],
  ["ladies-boxer-shorts-individuals", "Ladies Boxers"],
  ["ladies-briefs-individuals", "Low Rise Briefs"],
  ["ladies-thongs-individuals", "Thong"],
  ["seamless-individuals", "seamless"],
  ["full-seamless-individuals", "Seamless Full Briefs"],
  ["ladies-bamboo-boxer-shorts-individuals", "Ladies Bamboo Boxers"]
]);
  
	function getProducts(){
      console.log(choice)
		var url1 = `https://oddballs-data--development.gadget.app/apps/oddballs-data/product-by-type?type=${typeMap.get(choice)}`;
		var params1 = {
		  type: 'GET',
		  url: url1,
		  dataType: 'html'
		};
	
		$.ajax(params1).done(function (response1) {
		  var tempjson = JSON.parse(response1).prods.products;
		  const prods = tempjson.map(function(product){
			return(product.product)
		  })
          console.log(prods)
  
		  for(prod of prods){
          try{
			var available = false;
			var var_id;
			var prod_id;
			var style = "";
			if(prod){
			  prod_id = prod.id.replace("gid://shopify/Product/","");
			  for(variant of prod.variants){
				if(variant.title.toLowerCase() == size.toLowerCase()){
				  var_id = variant.id.replace("gid://shopify/ProductVariant/","");
				  if(variant.availableForSale){
					available = true;
				  }else{
					available = false;
				  }
				}
			  }
			  if(prod.handle.includes("vodafone") || prod.handle.includes("mystery")){
				available = false;
			  }
			  if(prod.variants[0].price != prod.variants[0].compare_at_price){
				available = false;
			  }
			}
			for (let tag of prod.tags.split(",")) {
				  tag = tag.replace(/g/, ",");
				if(tag.includes("style-")){
				  style = tag;
				}
			  }
			
			if(available){
			  
			  
			  const card = $('<div>').attr("data-prod_id", prod_id).attr("data-var_id", var_id).addClass("relative bab-bundle-item h-full").attr("data-title", prod.title).attr("data-price",prod.variants[0].price).attr("data-handle", prod.handle);
			  const numPop = $('<div>').addClass("absolute top-1 right-1 rounded-full bg-magenta-500 text-white px-2 js-bab-counter").css("display","none").text("0");
			  const img = $('<img>').attr("width","100%").attr("height","100%").attr("srcset",modifyUrlWithResolutions(prod.image)).attr("src",modifyUrlWithCustomResolutions(prod.image,200)).addClass("absolute top-0 left-0");
			  const padding = $('<div>').css("width","100%").css("padding-top", "100%");
			  card.append(img, padding, numPop);
			if(style.includes("classic")){
				  $('#bab-plain-prods').append(card)  
				}else if(style.includes("adventurous")){
				  $('#bab-patterned-prods').append(card)
				} 
            }

          }catch(error){
            console.error("error adding: " + prod.title);
            console.error(error)
          }
        }
        $('#bab-loading').hide();
        $('#bab-loaded').show();
  
		})
	  
	}
  
	function bundleUpdate(set_price){
	  var price = $('.bab-bundle-item').data("price"); 
	  var bundle_length = 0;
	  var total_price;
	  $('#bab-items-in-bundle').empty();
	  for(item of bundle){
		if(item[0] == 1){
			const card = $('<div>').addClass("bundle-item border border-gray-200 border-solid p-2 flex flex-col justify-between").attr("data-id",item[2]);
		  const img_div = $('<div>').addClass("relative w-full");
			const img = $('<img>').attr("src", item[3]).addClass("absolute")
		  const padding = $('<div>').addClass("w-full").css("padding-top","100%");
		  img_div.append(img,padding)
			const title = $('<div>').text(item[1]).addClass("font-bold text-md md:text-md leading-tight");
			const size_div = $('<div>').text(size).addClass("font-bold text-xs text-magenta uppercase");
			const removeButton = $('<div>')
			  .addClass("text-magenta-500 border border-solid js-bab-remove-button rounded-full px-3 py-1 w-full text-center mt-1")
			  .text("Remove")
			  .css({
				borderColor:"#f00f83",
				padding: '2px',
				borderRadius: '5px',
				cursor: 'pointer',
				fontWeight: 'bold',
				fontSize: '14px',
				transition: 'background-color 0.3s'
			  });
  
		  card.append(img_div, title, size_div, removeButton);
		  $('#bab-items-in-bundle').append(card);
		  bundle_length += 1;
		  
		}else{
		  bundle_length += parseInt(item[4]);
		}
	  }
	  
	  updateProgressBar(bundle_length);
	  if(set_price){
		price = set_price;
	  }
	  if(bundle_length >= bundle_buy_3){
		total_price = bundle_length*(price - bundle_save_3);
		$('#saver-bar-number-of-pairs').text("1");
		$('.saver-progress-savings').text(bundle_save_3 * (parseInt(bundle_length) + 1));
		$('#bab-not-complete').hide();
		$('#bab-complete').show();
		var total_saving = bundle_length * bundle_save_3;
		$('#bab-final-savings').html(total_saving);
		let the_bundle_length = get_bundle_length(bundle);
		const perPair = parseInt(total_price/the_bundle_length.toFixed(0));
		$('#bab-price-per-pair').text(perPair);
	  }else if (bundle_length >= bundle_buy_2){
		// $('#bab-not-complete').hide();
		// $('#bab-complete').show();
		var total_saving = bundle_length * bundle_save_2;
		$('#bab-final-savings').html(total_saving);
		total_price = bundle_length*(price - bundle_save_2);
		$('#saver-bar-number-of-pairs').text(bundle_buy_3 - bundle_length);
		$('.saver-progress-savings').text(bundle_save_3 * bundle_buy_3);
		let the_bundle_length = get_bundle_length(bundle);
		const perPair = parseInt(total_price/the_bundle_length.toFixed(0));
		$('#bab-price-per-pair').text(perPair);
	  }
	  else if (bundle_length >= bundle_buy_1){
		$('#bab-not-complete').show();
		$('#bab-complete').hide();
		$('#saver-bar-number-of-pairs').text(bundle_buy_2 - bundle_length);
		$('.saver-progress-savings').text(bundle_save_2 * bundle_buy_2);
		total_price = bundle_length*(price - bundle_save_1);
		let the_bundle_length = get_bundle_length(bundle);
		const perPair = parseInt(total_price/the_bundle_length.toFixed(0));
		$('#bab-price-per-pair').text(perPair);
	  }else{
		$('#bab-not-complete').show();
		$('#bab-complete').hide();
		$('#saver-bar-number-of-pairs').text(bundle_buy_1 - bundle_length);
		$('.saver-progress-savings').text(bundle_save_1 * bundle_buy_1);
		total_price = bundle_length*(price);
		let the_bundle_length = get_bundle_length(bundle);
		const perPair = parseInt(total_price/the_bundle_length.toFixed(0));
		$('#bab-price-per-pair').text(perPair);
	  }
	  if(bundle_length >= bundle_buy_1){
		$('#bab-compare-at-price').text("£" + price*bundle_length);
		 $('#bab-compare-at-price').show();
	  }else{
		$('#bab-compare-at-price').hide();
	  }
	  if(bundle_length == 0){
		$('#bab-price-per-pair').text(parseInt(price? price : 12))
			total_price = 0;
		  }
		$('#bab-saving-price').text("£" + total_price);
  
  
	  newBundle = bundle.filter(function(item){
		return item[0] == 1;
	  })
	   $('.bab-bundle-item').each(function(){
		  $(this).find(".js-bab-counter").text("0");
		 $(this).find(".js-bab-counter").hide();
	   })
	  for(each of newBundle){
		$('.bab-bundle-item').each(function(){
		  if($(this).data("var_id") == each[2]){
			$(this).find(".js-bab-counter").text(parseInt($(this).find(".js-bab-counter").text()) + 1);
			$(this).find(".js-bab-counter").show();
		  }
		})
	  }
	  let the_newBundle_length = get_bundle_length(bundle);
	  if(the_newBundle_length == 0){
		$('#add-bab-to-cart').text(translations.bab.select_prints);
		$('#add-bab-to-cart').addClass("pointer-events-none");
		$('#bab-empty-bundle').show();
		$('#bab-items-in-bundle-wrapper').hide()
		
	  }else{
		 $('#bab-empty-bundle').hide();
		$('#bab-items-in-bundle-wrapper').show();
		$('#add-bab-to-cart').text(translations.bab.add_to_cart);
		$('#add-bab-to-cart').removeClass("pointer-events-none");
	  }
	  const n = bundle.reduce(function(accumulator, currentValue) {
		return accumulator + (currentValue[4] || 1);
	  }, 0);
	  
	  const nthDiv = $('#bab-top-row .grid div:not(.absolute)').eq(n - 1);
	  $('#bab-top-row .grid div').removeClass("font-bold");
	  let the_bundle_length_old = get_bundle_length(bundle);
	  if(the_bundle_length_old != 0){
		nthDiv.addClass("font-bold");
	   
		
	  }
	  
  
	  
	}
  
	function updateProgressBar(bundle_length){
	  //$('#bab-bar').css("width",(bundle_length/6)*100 + "%");
	  var percentValue = (bundle_length/9)*100;
	  //$('#bab-bar').css("width",(percentValue + "%");
	  $('#bab-bar').css("width","100%");
	  const babBar = document.querySelector('#bab-bar');
	  const babBar_color1 = '#009fe2';
	  const babBar_color2 = '#d0288d';
	  const babBar_color3 =  '#e41087';
      const bundle_quanity =  get_bundle_length(bundle);
	  babBar.style.setProperty('--background', `linear-gradient(to right, ${babBar_color1}, ${babBar_color2}, ${babBar_color3})`);
	  babBar.style.setProperty('--progress', `${percentValue}%`);

      $('.unlocked').removeClass('unlocked')
      
      // Magenta to the save markers
     $('.bab-comp-marker').each(function(index) {
        if (index <= bundle_quanity - 3) {
            $(this).addClass("unlocked");      
        } else {
            return false; 
        }
    });
    

     // Magenta to the price markers
     $('.bab-price-marker').each(function(index) {
        if (index < bundle_quanity - 2) {
            $(this).addClass("unlocked");
        } else {
            return false; 
        }
    });
	}
  
		  function addToCartRecursive(index, item = false) {
			
			if (index >= bundle.length) {
			  if(item == false){
				$('body').trigger('refreshDrawer');
                updateCart()
				$('#bab-loading').hide();
				$('#bab-finished-screen').show()
                $('#bab-secondary-panel').removeClass("bab-finished")
				$('#bab-loading-message').html("Finding your pants");
			  }else{
				bundle = [];
			  $.getJSON('/cart.js', function (cart) {//get items from the cart into the bundle
				var bundle_choice = ""
				var temp_price = 0;
				  $.each(cart.items, function (index, item) {
					  var title_parts = item.title.split('-');
					  var item_size = item.variant_options[0];
					  if(item.properties._Bundle){
						  bundle_choice = item.properties._Bundle;
					  }
					if(bundle_choice != ""){
					  if(bundle_choice.toLowerCase().includes(bab_choice.toLowerCase())){
						  var quantity = item.quantity;
						  var handle = item.handle;
						  var price = item.price/100;
						  temp_price =  price;
						  var id = item.variant_id
						  bundle_in_cart = true;
						  bundle.push([0, item.title, id,item.featured_image.url, quantity]);
						
					  }
					}
				  })
					bundleUpdate(temp_price);
				  })
				$('.bab-bundle-item').each(function(){
				  if($(this).data("var_id") == item[2]){
					$(this).hide();
				  }
				})
				$('body').trigger('refreshDrawer');
				$('#bab-stock-error').html(`There was an error with ${item[1]}, please check your cart and try again`);
				$('#bab-stock-error').show();
				$('#bab-loading').hide();
				$('#bab-loaded').show();
				
			  }
			  
			  return;
			}
			
			var currentItem = bundle[index];
			$('#bab-loaded').hide();
			$('#bab-loading').show();
			$('#bab-loading-message').html("Adding your bundle to cart");
		if (currentItem[0] == 1) {
			var variant_id = currentItem[2];
			var data = {
				quantity: 1,
				id: variant_id,
				properties: {}
				}
				data.properties['_bab-landing'] = variant_id;
				data.properties['_freeshp'] = "";
                
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: data,
				dataType: 'json',
				success: function(response) {
					addToCartRecursive(index + 1, item);
				},
				error: function(error) {
					console.error('Error adding product to cart:', error);
					addToCartRecursive(index + 1, currentItem);
				  
				},
			});
		} else {
			addToCartRecursive(index + 1, item);
		}
		}



  
        
      
        function loadSizeGuide($clickedElement, guideHref) {
        const sizeGuidePopup = document.getElementById("size-guide-popup-content");
        // Store references to the elements
        const $button = $clickedElement;
        const $tapeIcon = $button.find('.tape-svg');
        const $loader = $button.find('.circular-loader');
        
        // Show loading state
        $tapeIcon.addClass('hidden');
        $loader.removeClass('hidden');
        
        // Load the guide
        $('#size-guide-content').load(guideHref, function(response, status, xhr) {
            if (status === "success") {
                
                // Reset button state
                $tapeIcon.removeClass('hidden');
                $loader.addClass('hidden');
                
                // Open the popup
                openPopup(sizeGuidePopup);
            } else {
                console.error('Error loading size guide:', xhr.status, xhr.statusText);
                
                // Reset button state
                $tapeIcon.removeClass('hidden');
                $loader.addClass('hidden');
                
                // Show error message
                $('#size-guide-content').html(`
                    <div class="error-message">
                        Failed to load size guide. Please try again.
                    </div>
                `);
               openPopup(sizeGuidePopup);
            }
        });
    }
  
		$('body').on('click','.js-match-size-guide-show', function(){
		if(temp_step_1_gender == "men"){
		  loadSizeGuide($(this), '/pages/all-size-guides #Mens-Underwear-Size-Guide')
		}else{
		  loadSizeGuide($(this), '/pages/all-size-guides #Womens-Underwear-Size-Guide')
		}
		
	  })
  
	 function modifyUrlWithCustomResolutions(url, resolution) { //used to add a resolution to a product image url
	  var parts = url.split('.');
	  var fileName = parts.slice(0, -1).join('.'); 
	  var fileExtension = parts[parts.length - 1];
	  var modifiedUrl = fileName + "_" + resolution + "x." + fileExtension ;
	
	  return modifiedUrl;
	}
	  function modifyUrlWithResolutions(url) { // used to return a source set with multiple resolutions
	  var resolutions = [360, 420, 480, 640, 840, 1080, 1280, 1540, 1860, 1950];
	  var parts = url.split('.');
	  var fileName = parts.slice(0, -1).join('.'); 
	  var fileExtension = parts[parts.length - 1];
	  var modifiedUrls = [];
	
	  for (var i = 0; i < resolutions.length; i++) {
		var resolution = resolutions[i];
		var modifiedUrl = fileName + "_" + resolution/5 + "x." + fileExtension + " " + resolution/5 + "w";
		modifiedUrls.push(modifiedUrl);
	  }
	
	  var result = '';
	  for (var j = 0; j < modifiedUrls.length; j++) {
		result += modifiedUrls[j];
		if (j !== modifiedUrls.length - 1) {
		  result += ',';
		}
		
	  }
	  //return("")
	  return result;
	}

    $('body').on('click', '.slider-control', function () {
  
        var position = $(this).index()
        var text = $(this).text()
        var translatePositionX = ((position) * 100) + "%"
        var slider = $(this).siblings('.selection-tab-selection')
        slider.css('transform', `translate(${translatePositionX}, -50%)`);

        (position > 0)? slider.css('left', '-1%') : slider.css('left', '1%')
        
          
        
        
         if (slider.hasClass("hidden")) {
            slider.removeClass('hidden');
          }
    });

    $('#bab-men').click()
  })